"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = react_1.default.createContext({
    updateFormState: () => {
        // no-op
    },
    hasBeenSubmitted: false,
    submitButtonDisabled: false,
    values: {}
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udGV4dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9mb3JtL2NvbnRleHQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxrREFBMEI7QUFHMUIsa0JBQWUsZUFBSyxDQUFDLGFBQWEsQ0FBYztJQUM5QyxlQUFlLEVBQUUsR0FBRyxFQUFFO1FBQ3BCLFFBQVE7SUFDVixDQUFDO0lBQ0QsZ0JBQWdCLEVBQUUsS0FBSztJQUN2QixvQkFBb0IsRUFBRSxLQUFLO0lBQzNCLE1BQU0sRUFBRSxFQUFFO0NBQ1gsQ0FBQyxDQUFDIn0=